import { assigneeLabels } from '../constants/assignee';

/**
 * 担当者表示判定の入力候補ユーザー
 * - getUsersByCompanyId() の結果からマッピングした最小情報
 */
export interface AssigneeOption {
  uid: string;
  name: string;
  iconUrl: string | null;
}

/**
 * 担当者表示の解決結果
 */
export interface AssigneeDisplayInfo {
  /** 画面表示する名前（退会済時は「退会済ユーザー」、未設定時は「-」） */
  displayName: string;
  /** 画面表示するアイコンURL（退会済時や未設定時は null） */
  displayIconUrl: string | null;
  /** 担当者が退会済かどうか（設定済 かつ 候補リストに存在しない） */
  isWithdrawn: boolean;
  /** 担当者が未設定かどうか（assigneeId が undefined / 空文字） */
  isUnassigned: boolean;
}

/**
 * 担当者の表示情報を解決する（#2642）
 *
 * 判定優先度:
 *   1. assigneeId 未設定                            → 「-」表示
 *   2. 候補リスト未ロード(options.length === 0)     → DB スナップショット値で表示
 *   3. 候補リストロード済 かつ 候補に存在しない     → 「退会済ユーザー」
 *   4. 上記以外                                     → 候補リストの名前/アイコンを優先
 *
 * 一覧画面・結果画面・将来の他画面で同一の判定を行うために本関数を共通利用する。
 */
export const resolveAssigneeDisplay = (
  assigneeId: string | undefined | null,
  assigneeName: string | undefined | null,
  assigneeIconUrl: string | undefined | null,
  options: AssigneeOption[],
): AssigneeDisplayInfo => {
  const assigneeInfo = assigneeId ? options.find(o => o.uid === assigneeId) : undefined;
  const isUnassigned = !assigneeId;
  const isWithdrawn = options.length > 0 && !!assigneeId && !assigneeInfo;

  const displayName = isWithdrawn
    ? assigneeLabels.withdrawnLabel
    : (assigneeInfo?.name ?? assigneeName ?? '-');
  const displayIconUrl = isWithdrawn ? null : (assigneeInfo?.iconUrl ?? assigneeIconUrl ?? null);

  return {
    displayName,
    displayIconUrl,
    isWithdrawn,
    isUnassigned,
  };
};
